import { Component, Input } from '@angular/core';
import { OverlayComponent } from '@overlays/overlay/overlay.component';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [NgStyle],
})
export class AvatarComponent extends OverlayComponent {
  @Input() avatarUri: string | undefined;
  @Input() title: string = 'Avatar profile image';
  @Input() userInitials: string;

  /**
   * Update the overlay styles based on the viewport size
   */
  override updateOverlayStyles(): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { playerWidth = 0, playerHeight = 0, browserHeight = 0, browserWidth = 0 } = this.viewportSize || {};

    // Calculate dimensions and position
    let width: number | string;
    let calcFontSize: number | string;
    // NOTE: Check if browser height is really big or when the
    // browser winodw is narrow. Adjust the overlay to mat
    // the smaller player height and widths.
    if (browserHeight > browserWidth) {
      width = `6vw`;
      calcFontSize = '3vw';
    } else {
      width = `7vw`;
      calcFontSize = '3vw';
    }

    this.overlayStyles = {
      width: `${width}`,
      height: `${width}`,
      fontSize: `${calcFontSize}`,
    };
  }
}
